import request from "@/utils/request";
import md5 from 'js-md5'
import QS from 'qs'
import { sortASCII } from '@/utils'
import config from '@/config/index'
import enumObject from "@/utils/enum";
const GateWay = enumObject.providerConfig[config.projectName].gateway;
// 转发接口
export function currencyPost (data) {
  return request({
    url: GateWay + "/frontEnd/api/currencyPost",
    method: "post",
    data
  });
}
// 上传接口
export function upload (data, headers) {
  return request({
    url: GateWay + "/img/upload",
    method: "post",
    data,
    headers
  });
}
// jn欠费历史消息推送
export function messagePush (data) {
  return request({
    url: GateWay + "/wx/messagePush",
    method: "post",
    data
  });
}
// 预约停车记录
export function getRecord (data) {
  return request({
    url: GateWay + "/backstage/api/getRecordV1",
    method: "post",
    data
  });
}
// 取消预约停车
export function cancelAppointment (data) {
  return request({
    url: GateWay + "/temporary/cancelAppointment",
    method: "post",
    data
  });
}
// 预约停车
export function appointmentParking (data) {
  return request({
    url: GateWay + "/temporary/appointmentParking",
    method: "post",
    data
  });
}
// 获取预约停车场车位
export function queryParkingLot (data) {
  return request({
    url: GateWay + "/temporary/queryParkingLot",
    method: "post",
    data

  });
}
//查询开票历史
export function getBillingHistory (data) {
  return request({
    url: GateWay + "/invoicing/api/getBillingHistory",
    method: "post",
    data
  });
}

// 根据停车场配置是否显示图片按钮
export function getJNJTJTConfigure () {
  return request({
    url: GateWay + "/mainPlatform/getJNJTJTConfigure",
    method: "get",
  });
}
// 根据停车场配置是否显示图片
export function queryDisplayCycle () {
  return request({
    url: GateWay + "/mainPlatform/queryDisplayCycle",
    method: "get",
  });
}
// 根据停车场配置显示下拉周期
export function getStopRecordingToConfigure () {
  return request({
    url: GateWay + "/mainPlatform/getStopRecordingToConfigure",
    method: "get",
  });
}
//根据车牌查询停车费
export function getStopCarInfo (data) {
  return request({
    url: GateWay + "/mainPlatform/queryFee",
    method: "post",
    data: data
  });
}
//根据车牌及id查询停车费
export function getById (data) {
  return request({
    url: GateWay + "/mainPlatform/getByIdV1",
    method: "post",
    data
  });
}
//根据硬件地址查询停车费
export function getStopCarInfoByMac (data) {
  return request({
    url: GateWay + "/mainPlatform/getStopCarInfoByMac",
    method: "post",
    data
  });
}
//查询用户车牌绑定关系
export function selectCarAndUserRel (data) {
  return request({
    url: GateWay + "/handleWx/selectCarAndUserRel",
    method: "post",
    data
  });
}
//修改用户车牌绑定关系
export function updateCarAndUserRel (data) {
  return request({
    url: GateWay + "/handleWx/updateCarAndUserRel",
    method: "post",
    data
  });
}
//添加用户车牌绑定关系
export function addCarAndUserRel (data) {
  return request({
    url: GateWay + "/handleWx/addCarAndUserRel",
    method: "post",
    data
  });
}
//根据ID删除绑定关系
export function deleteCarAndUserRel (data) {
  return request({
    url: GateWay + "/handleWx/deleteCarAndUserRel",
    method: "post",
    data
  });
}
// //根据openId查询缴费记录
export function selectWxPaidrecordList (data) {
  return request({
    url: GateWay + "/record/api/paymentRecordV1",
    method: "post",
    data
  });
}
//根据openId查询缴费记录
// export function selectWxPaidrecordList (data) {
//   return request({
//     url: GateWay +"/handleWx/selectWxPaidrecordList",
//     method: "post",
//     data
//   });
// }
//根据车牌号查询欠费订单
export function getArrearsList (data) {
  return request({
    url: GateWay + "/mainPlatform/getArrearsList",
    method: "post",
    data
  });
}
//根据parkId查询商户
export function getMerchantByParkId (data) {
  return request({
    url: GateWay + "/handleWx/selectWxParkmerchant",
    method: "post",
    data
  });
}
